import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import { Apollo } from 'apollo-angular';
import { CommitteeApprovalDashboardService } from '../committee-approval-dashboard.service';

import { add_project_disclosure } from './graphql/addProjectDisclosure';
import { update_project_disclosure } from './graphql/updateProjectDisclosure';
import { UserPermissionsService } from 'src/app/services/user-permissions.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import Milestone from 'src/app/interfaces/milestone';
import Project from 'src/app/interfaces/project';
import ProjectDisclosure from 'src/app/interfaces/project-disclosure';
import { FormControl } from "@angular/forms";
import { Subscription } from "rxjs";

const ADD_PROJECT_DISCLOSURE = add_project_disclosure;
const UPDATE_PROJECT_DISCLOSURE = update_project_disclosure;

@Component({
    selector: 'app-disclosures-editor',
    templateUrl: './disclosures-editor.component.html',
    styleUrls: [
      './disclosures-editor.component.scss',
      '../../../../node_modules/@kolkov/angular-editor/themes/default.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DisclosuresEditorComponent implements OnInit {
  @Input() disclosure: ProjectDisclosure;
  @Input() milestone: Milestone;
  @Input() currentMilestone: Milestone;
  @Input() readOnly: boolean;
  @Input() project: Project;
  @Output() updateHTML = new EventEmitter<ProjectDisclosure>();
  public show = false;
  public editorConfig: AngularEditorConfig = {
    editable:true,
    height: 'auto',
    width: '100%',
    toolbarHiddenButtons:[
      ['insertImage','insertVideo'],
      ['toggleEditorMode']
    ]
  }
  public editConfig = {
    toolbar: [
      'heading',
      '|',
      'bold',
      'italic',
      'underline',
      'strikethrough',
      '|',
      'fontSize',
      'fontFamily',
      'fontColor',
      'fontBackgroundColor',
      'highlight',
      'blockQuote',
      '|',
      'alignment',
      'outdent',
      'indent',
      '|',
      'bulletedList',
      'numberedList',
      '|',
      'link',
      'insertTable',
      '|',
      'removeFormat',
      'undo',
      'redo',
    ],
  };
  editorHTML = new FormControl<string|null>(null);
  waiting: boolean = false;
  valueSub: Subscription;
  constructor(
    private CommitteeApprovalDashboardService: CommitteeApprovalDashboardService,
    private apollo: Apollo,
    public permsService: UserPermissionsService
  ) {}

  ngOnInit(): void {
    this.editorHTML.setValue( this.disclosure.disclosures as string);
    this.permsService.getUserPermissions('PROJECTDISCLOSURE', null);
    if (
      this.currentMilestone &&
      this.currentMilestone.id === this.milestone.id
    ) {
      this.show = true;
    } else if (!this.currentMilestone) {
      this.show = true;
    }
    this.valueSub = this.editorHTML.valueChanges.subscribe((value) => {
      if(value){
        this.updateHTML.emit({ ...this.disclosure, disclosures: value });
      }
    });
  }
  ngOnDestroy() {
    this.valueSub?.unsubscribe();
  }

  save() {
    this.updateHTML.emit(this.disclosure);
    if (this.disclosure.disclosures !== this.disclosure.copy) {
      let callType: any;
      let callVar: any;
      if (this.disclosure.id === 'new') {
        callType = ADD_PROJECT_DISCLOSURE;
        callVar = {
          project_id: this.project.id,
          disclosures: this.disclosure.disclosures,
          milestone_id: this.milestone.id,
        };
      } else {
        callType = UPDATE_PROJECT_DISCLOSURE;
        callVar = {
          id: this.disclosure.id,
          disclosures: this.disclosure.disclosures,
        };
      }
      this.waiting = true;
      let sub = this.apollo
        .mutate({
          mutation: callType,
          variables: callVar,
        })
        .subscribe(
          (data: any) => {
            this.waiting = false;
            this.updateHTML.emit({
              ...this.disclosure,
              id: data.data.disclosure?.id,
              copy: data.data.disclosure?.disclosures,
            });
            sub && sub.unsubscribe();
          },
          (error) => {
            this.waiting = false;
            this.updateHTML.emit({
              ...this.disclosure,
              copy: this.disclosure.disclosures,
            });
            sub && sub.unsubscribe();
          }
        );
    }
  }

}
